import React from 'react';
import { Image, Transformation } from 'cloudinary-react';
import { DEFAULT_PROFILE_PHOTO_SIZE } from '../../lib/utils';
import { CLOUD_NAME, PROFILE_BUCKET_NAME } from '../../lib/cloudinary';

function ProfilePhoto({ publicId = '', size = DEFAULT_PROFILE_PHOTO_SIZE }) {
  return (
    <Image
      cloudName={CLOUD_NAME}
      publicId={`${PROFILE_BUCKET_NAME}/${publicId}.png`}
    >
      <Transformation
        width={size}
        height={size}
        crop="thumb"
        radius="max"
        gravity="face"
      />
    </Image>
  );
}

export default ProfilePhoto;
